<div id="cms-partial-category-top">
  <!-- ROWS -->

  @if (!isEmpty(get(data, 'rows'))) {
    <div id="rows">
      @for (row of get(data, 'rows', []); track row; let i = $index) {
        <div>
          @if (get(row, 'category_top_banner', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-hero-banner
                [bannerRow]="row"
                [dataUrl]="data?.url"
                [dataTitle]="data?.title"
                [solutionID]="marketoSolutionsID"
              ></cms-partial-category-top-hero-banner>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 400px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 400px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- STEP BY STEP -->
          @if (get(row, 'step_by_step', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-step-by-step [stepByStepRow]="row">
              </cms-partial-category-top-step-by-step>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- FULL WIDTH IMAGE AND TEXT -->
          @if (get(row, 'image_and_text.full_width_image_and_text', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-full-width-image-and-text
                [fullWidthImageAndTextRow]="row"
                [dataUrl]="data?.url"
                [dataTitle]="data?.title"
                [solutionID]="marketoSolutionsID"
              ></cms-partial-category-top-component-full-width-image-and-text>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- FEATURE SOLUTIONS -->
          @if (get(row, 'feature_solutions', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-feature-solutions
                [featureSolutionsRow]="row"
                [dataUrl]="data?.url"
                [dataTitle]="data?.title"
                [solutionID]="marketoSolutionsID"
              ></cms-partial-category-top-feature-solutions>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 400px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 400px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- TABLE -->
          @if (get(row, 'tables', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-table
                [tableRow]="row.tables.tables[0]"
              ></cms-partial-category-top-component-table>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- INTERNAL LINKS -->
          @if (!isEmpty(get(row, 'internal_links.internal_link_reference', []))) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-internal-links
                [internalLinksRow]="row"
              ></cms-partial-category-top-internal-links>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- FULL WIDTH BLOCK -->
          @if (get(row, 'full_width_block')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-full-width-block
                [fullWidthRow]="row"
              ></cms-partial-category-top-component-full-width-block>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- VALUE PROPS -->
          @if (get(row, 'value_props', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-value-props
                [valuePropsRow]="row"
              ></cms-partial-category-top-component-value-props>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- LEAD GEN -->
          @if (get(row, 'lead_gen', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-lead-gen
                [leadGenRow]="row"
                [dataUrl]="data?.url"
                [dataTitle]="data?.title"
                [solutionID]="marketoSolutionsID"
              ></cms-partial-category-top-lead-gen>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- LOGOS -->
          @if (get(row, 'logos', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-logos [logosRow]="row"></cms-partial-category-top-logos>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 100px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 100px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- IMAGE AND TEXT -->
          @if (!isEmpty(get(row, 'image_and_text.image_and_text', '')) || !isEmpty(get(row, 'image_and_text.text_block', ''))) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-image-and-text
                [imageAndTextRow]="row"
                [dataUrl]="data?.url"
                [dataTitle]="data?.title"
                [solutionID]="marketoSolutionsID"
                [uniqueIndex]="i"
              ></cms-partial-category-top-component-image-and-text>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 250px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 250px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- ACCORDION -->
          @if (!isEmpty(get(row, 'accordion.accordion', ''))) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-accordion
                [accordionRow]="row"
                [dataUrl]="data?.url"
                [dataTitle]="data?.title"
                [solutionID]="marketoSolutionsID"
                [uniqueIndex]="i"
              ></cms-partial-category-top-component-accordion>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- SUBCATEGORY LINKS -->
          @if (get(row, 'subcategory_links', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-subcategory-links
                [subcategoryLinksRow]="row"
              ></cms-partial-category-top-component-subcategory-links>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 150px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 150px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- SUBCATEGORY LINKS V2 -->
          @if (get(row, 'subcategory_links_v2', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-subcategory-links-v2
                [subcategoryLinksV2Row]="row"
              ></cms-partial-category-top-component-subcategory-links-v2>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 150px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 150px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- EMLI TABLE -->
          <div>
            @if (get(row, 'miscellaneous_content.emli_table', false)) {
              <section
                [class.gray-bg]="get(row, 'miscellaneous_content.gray_background', false)"
                >
                <div class="fx-row-container fx-wrap px-3">
                  <app-emli-table></app-emli-table>
                </div>
              </section>
            }
            @if (get(row, 'miscellaneous_content.split_line', '')) {
              <hr class="m-0 mb-3" />
            }
          </div>
          <!-- RELATED CONTENT -->
          @if (get(row, 'related_content', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-related-content
                [relatedContentRow]="data"
              ></cms-partial-category-top-component-related-content>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- MULTIPLE COLUMNS -->
          @if (get(row, 'multi_columns', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-multiple-columns
                [multipleColumnsRow]="row"
              ></cms-partial-category-top-multiple-columns>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- MULTIPLE COLUMNS V2 -->
          @if (get(row, 'multi_column_v2', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-multiple-columns-v2
                [multipleColumnsRow]="row"
                [solutionID]="marketoSolutionsID"
                [dataUrl]="data?.url"
                [dataTitle]="data?.title"
              ></cms-partial-category-top-multiple-columns-v2>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- VIDEO -->
          @if (get(row, 'video', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-video [videoColumnsRow]="row"></cms-partial-category-top-video>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- PRODUCT OPTIONS -->
          @if (get(row, 'product_options', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-product-options
                [productOptionsRow]="row"
              ></cms-partial-category-top-component-product-options>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- PRODUCT OPTIONS 2 (R - Product Options) -->
          @if (!isEmpty(get(row, 'product_options_2.product_options', ''))) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-product-options-2
                [productOptionsRow]="row"
              ></cms-partial-category-top-component-product-options-2>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- COLOR BLOCK -->
          @if (get(row, 'colored_block', '')) {
            @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
              <cms-partial-category-top-component-colored-block
                [coloredBlockRow]="row"
                [dataUrl]="data?.url"
                [dataTitle]="data?.title"
                [solutionID]="marketoSolutionsID"
              ></cms-partial-category-top-component-colored-block>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
        </div>
      }
    </div>
  }

  <!-- CATEGORY TOP FACETS -->
  @if (!isEmpty(get(data, 'rowSets'))) {
    @defer (on viewport; on idle; hydrate on viewport; hydrate on idle) {
      <cms-partial-category-top-component-facets [facetRowSet]="data">
      </cms-partial-category-top-component-facets>
    } @placeholder {
      <div class="skeleton-loader" style="min-height: 300px;"></div>
    } @loading (minimum 200ms) {
      <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
        <div class="spinner"></div>
      </div>
    }
  }
</div>
